import { render, staticRenderFns } from "./MintalMesPrdSmeltingResistanceBeforeIronEdit.vue?vue&type=template&id=5b012776&"
import script from "./MintalMesPrdSmeltingResistanceBeforeIronEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSmeltingResistanceBeforeIronEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports